export function Resigin() {
  // get redirect path from url
  const redirectPath = new URLSearchParams(window.location.search).get(
    'redirect_to'
  )
  // check if it's same host
  const isSameHost =
    redirectPath && new URL(redirectPath).host === window.location.host

  // clear cookies and local storage
  window.localStorage.clear()
  window.sessionStorage.clear()
  document.cookie.split(';').forEach((c) => {
    document.cookie = c
      .replace(/^ +/, '')
      .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/')
  })

  if (isSameHost) {
    // Redirect to the same host
    window.location.href = redirectPath
  }

  return null
}
